module.exports = __webpack_public_path__ + "static/media/prime-header.63790588.jpg";